import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "delete-clock--sprite",
  "use": "delete-clock--sprite-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"delete-clock--sprite\">\n    <path d=\"M13 12H14.5V14.82L16.94 16.23L16.19 17.53L13 15.69V12ZM21 15C21 18.87 17.87 22 14 22C12.09 22 10.36 21.24 9.1 20H6C4.9 20 4 19.1 4 18V6H16V8.29C18.89 9.15 21 11.83 21 15ZM14 10C11.24 10 9 12.24 9 15C9 17.76 11.24 20 14 20C16.76 20 19 17.76 19 15C19 12.24 16.76 10 14 10ZM17 3V5H3V3H6.5L7.5 2H12.5L13.5 3H17Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol